<template>
    <div>
      <template v-if="accountLoaded">

  <a-select v-model="project" mode="multiple" show-search allow-clear @change="changed" placeholder="请选择用户">
      <a-select-option v-for="user in users" :key="user.id" :value="user.id">
        <span class="text-color-secondary option-prefix">{{ $t('dictionary.user') }}: </span>{{ user.name }}
      </a-select-option>
  </a-select>
      </template>
  <template v-else>
      <a-spin />
    </template>
    </div>
</template>

<script>
export default {
  data () {
    return {
      accountLoaded: false,
      users: [],
    }
  },
  async created () {
    this.users = await this.getUserList()
    this.accountLoaded = true
  },
  methods: {
    async getUserList () {
      const res = await this.$http.get(`/v1/users?details=${true}&limit=0&offset=0`)
      return res.data?.data ?? []
    },
    changed (value) {
      this.$emit('change', value)
    },
  },
}
</script>
